export const RUN_PERCENT = 'RUN_PERCENT';
export const DEFAULT_PERCENT = 'DEFAULT_PERCENT';
